// GENERATED BY ./src/scripts/generateComponents.ts
// DO NOT EDIT IT MANUALLY

import React from "react";

import { iconStatapteusde } from "../../../icons/full/build/icon-statapteusde.icon";
import { IconComponentBaseProps } from "../../../utils";
import { Image } from "../../Base/Image";

const StatapteusdeIcon = (props: IconComponentBaseProps) => {
  return <Image svgCode={iconStatapteusde.data} {...props} />;
};

if (process.env.NODE_ENV !== 'production') {
  StatapteusdeIcon.displayName = 'StatapteusdeIcon';
}

export default StatapteusdeIcon;